<h1 mat-dialog-title>
	{{ title }}
</h1>
<div mat-dialog-content>
	<p>	{{ text }}</p>
	<div>
		<input id="file" type="file" [accept]="accept" (change)="onFileInputChange($any($event.target).files)"/>
	</div>
</div>
<div mat-dialog-actions style="justify-content: flex-end; display: flex;">
	<button mat-raised-button color="warn" (click)="onCancelClick()">
		{{ cancelBtnText | translate }}
	</button>
	<button mat-raised-button color="primary" (click)="onOkClick()">
		{{ okBtnText | translate }}
	</button>
</div>
